import { CLOSE_SMART_BANNER, SmartAppBannerActions } from '../actions/smartBannerActions';

interface SmartBannerState {
    isSmartBannerClosed: boolean;
}

const initialState: SmartBannerState = {
    isSmartBannerClosed: false
};

export const smartAppBanner = (
    state: SmartBannerState = initialState,
    action: SmartAppBannerActions
): SmartBannerState => {
    switch (action.type) {
        case CLOSE_SMART_BANNER:
            return {
                ...state,
                isSmartBannerClosed: action.payload
            };
        default:
            return state;
    }
};
